import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { useParams, useNavigate } from "react-router-dom";
import styles from "./SeriesPage.module.css";
import ProductCard from "../../components/Furniture-Gallery/ProductCard";
import { getProductsBySeries } from "../../service/galleryService";
import LoadingSpinner from "../../components/LoadingSpinner";
import ReactPaginate from "react-paginate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilter,
  faSearch,
  faSortAmountDown,
  faChair,
  faDesktop,
  faUsers,
  faHospital,
  faUtensils,
  faSchool,
  faUserTie,
  faBed,
  faLaptop,
  faTimes,
  faArrowRight,
  faArrowLeft,
  faPalette,
  faDollarSign,
  faStar,
  faClock,
  faEraser,
  faChevronDown,
  faCheckCircle,
  faLayerGroup,
  faAngleDoubleUp,
  faAngleDoubleDown,
  faSlidersH,
} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import { Helmet } from "react-helmet-async";
import { motion, AnimatePresence } from "framer-motion";
import PriceRangeSlider from "../../components/PriceRangeSlider";
import { Button } from "react-bootstrap";
import classNames from "classnames";

// Series icons mapping
const seriesIcons = {
  "Bar Stool Series": faUtensils,
  "Cafeteria Series": faUtensils,
  "Cyber Series": faLaptop,
  "Director Series": faUserTie,
  "Dressing Series": faBed,
  "Executive Series": faUserTie,
  "Mesh Series": faChair,
  "Office Table Series": faDesktop,
  "Student Series": faSchool,
  "Visitor Series": faUsers,
  "Hospital Series": faHospital,
};

// Series background images mapping
const seriesBackgrounds = {
  "Bar Stool Series":
    "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
  "Cafeteria Series":
    "https://images.unsplash.com/photo-1554679665-f5537f187268?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
  "Cyber Series":
    "https://images.unsplash.com/photo-1497366754035-f200968a6e72?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80",
  "Director Series":
    "https://images.unsplash.com/photo-1497366811353-6870744d04b2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80",
  "Dressing Series":
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2058&q=80",
  "Executive Series":
    "https://images.unsplash.com/photo-1565791380715-23b6835f49cf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
  "Mesh Series":
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2058&q=80",
  "Office Table Series":
    "https://images.unsplash.com/photo-1497366811353-6870744d04b2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80",
  "Student Series":
    "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
  "Visitor Series":
    "https://images.unsplash.com/photo-1497366811353-6870744d04b2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80",
  "Hospital Series":
    "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2053&q=80",
};

interface SortOption {
  value: string;
  label: string;
  icon: any;
}

const SeriesPage = () => {
  const { seriesId } = useParams();
  const navigate = useNavigate();
  const [series, setSeries] = useState<any>(null);
  const [products, setProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [totalProducts, setTotalProducts] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(12);
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOption, setSortOption] = useState("createdAt_desc");
  const [priceRange, setPriceRange] = useState([0, 100000]);
  const [selectedColors, setSelectedColors] = useState<string[]>([]);
  const [appliedFiltersCount, setAppliedFiltersCount] = useState(0);
  const [showFilters, setShowFilters] = useState(true);

  // Available filters state
  const [availableFilters, setAvailableFilters] = useState({
    colors: [],
    priceRange: {
      minPrice: 0,
      maxPrice: 100000,
    },
  });

  // Debounce refs
  const searchTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const filterTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const initialLoadRef = useRef(true);

  // Sort options
  // Update your sortOptions to include icons in the label
  const sortOptions: SortOption[] = useMemo(
    () => [
      {
        value: "createdAt_desc",
        label: "Newest First",
        icon: faClock,
      },
      {
        value: "createdAt_asc",
        label: "Oldest First",
        icon: faClock,
      },
      {
        value: "ourPrice_asc",
        label: "Price: Low to High",
        icon: faDollarSign,
      },
      {
        value: "ourPrice_desc",
        label: "Price: High to Low",
        icon: faDollarSign,
      },
      {
        value: "name_asc",
        label: "Name: A-Z",
        icon: faSortAmountDown,
      },
      {
        value: "name_desc",
        label: "Name: Z-A",
        icon: faSortAmountDown,
      },
      {
        value: "popularity_desc",
        label: "Most Popular",
        icon: faStar,
      },
    ],
    []
  );

  // Update the formatOptionLabel for the select
  const formatOptionLabel = (option: any) => (
    <div className={styles.sortOption}>
      <FontAwesomeIcon icon={option.icon} className={styles.sortOptionIcon} />
      <span>{option.label}</span>
    </div>
  );
  // Calculate applied filters count
  useEffect(() => {
    let count = 0;
    if (searchQuery) count++;
    if (sortOption !== "createdAt_desc") count++;
    if (
      priceRange[0] > availableFilters.priceRange.minPrice ||
      priceRange[1] < availableFilters.priceRange.maxPrice
    )
      count++;
    if (selectedColors.length > 0) count++;
    setAppliedFiltersCount(count);
  }, [searchQuery, sortOption, priceRange, selectedColors, availableFilters]);

  // Optimized fetchProducts function
  const fetchProducts = useCallback(async () => {
    try {
      setLoading(true);

      const [sortBy, sortOrder] = sortOption.split("_");

      const params: Record<string, any> = {
        pageNumber: currentPage + 1,
        pageSize,
        search: searchQuery,
        sortBy,
        sortOrder,
        minPrice: priceRange[0],
        maxPrice: priceRange[1],
      };

      if (selectedColors.length > 0) {
        params.color = selectedColors;
      }

      // Clean up params
      Object.keys(params).forEach((key) => {
        if (params[key] === undefined || params[key] === "") {
          delete params[key];
        }
      });

      const data = await getProductsBySeries(seriesId!, params);

      if (data?.success) {
        setProducts(data.data || []);
        setTotalProducts(data.pagination?.total || 0);
        setSeries(data.filters?.seriesData);

        if (data.filters?.available) {
          const newAvailableFilters = {
            colors: data.filters.available.colors || [],
            priceRange: data.filters.available.priceRange || {
              minPrice: 0,
              maxPrice: 100000,
            },
          };
          // @ts-ignore
          setAvailableFilters(newAvailableFilters);

          if (priceRange[0] === 0 && priceRange[1] === 100000) {
            setPriceRange([
              newAvailableFilters.priceRange.minPrice,
              newAvailableFilters.priceRange.maxPrice,
            ]);
          }
        }
      } else {
        setError("Unexpected data format received from server");
      }
    } catch (err: any) {
      setError(err.message || "Failed to load series data");
      console.error("Error loading series:", err);
    } finally {
      setLoading(false);
      initialLoadRef.current = false;
    }
  }, [
    seriesId,
    currentPage,
    pageSize,
    searchQuery,
    sortOption,
    priceRange,
    selectedColors,
  ]);

  // Main data fetching effect
  useEffect(() => {
    if (initialLoadRef.current) {
      fetchProducts();
    }
  }, [fetchProducts]);

  // Debounced effects for search and filters
  useEffect(() => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(() => {
      setCurrentPage(0);
      fetchProducts();
    }, 500);

    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [searchQuery, sortOption, fetchProducts]);

  useEffect(() => {
    if (filterTimeoutRef.current) {
      clearTimeout(filterTimeoutRef.current);
    }

    filterTimeoutRef.current = setTimeout(() => {
      setCurrentPage(0);
      fetchProducts();
    }, 300);

    return () => {
      if (filterTimeoutRef.current) {
        clearTimeout(filterTimeoutRef.current);
      }
    };
  }, [priceRange, fetchProducts]);

  // Immediate effect for other filters
  useEffect(() => {
    setCurrentPage(0);
    fetchProducts();
  }, [selectedColors.length, fetchProducts]);

  // Event handlers
  const handleSearchChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setSearchQuery(e.target.value);
    },
    []
  );

  const handlePriceChange = useCallback((values: number[]) => {
    setPriceRange(values);
  }, []);

  const handleColorChange = useCallback((colorValue: string) => {
    setSelectedColors((prev) =>
      prev.includes(colorValue)
        ? prev.filter((c) => c !== colorValue)
        : [...prev, colorValue]
    );
  }, []);

  const handleSortChange = useCallback((selectedOption: any) => {
    setSortOption(selectedOption.value);
  }, []);

  const handlePageSizeChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      setPageSize(Number(e.target.value));
      setCurrentPage(0);
    },
    []
  );

  const handlePageClick = useCallback((selectedItem: { selected: number }) => {
    setCurrentPage(selectedItem.selected);
  }, []);

  const resetFilters = useCallback(() => {
    setSearchQuery("");
    setSortOption("createdAt_desc");
    setPriceRange([
      availableFilters.priceRange.minPrice,
      availableFilters.priceRange.maxPrice,
    ]);
    setSelectedColors([]);
    setCurrentPage(0);
  }, [
    availableFilters.priceRange.minPrice,
    availableFilters.priceRange.maxPrice,
  ]);

  const clearSelectedColors = useCallback(() => {
    setSelectedColors([]);
  }, []);

  // Clean up timeouts on unmount
  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
      if (filterTimeoutRef.current) clearTimeout(filterTimeoutRef.current);
    };
  }, []);

  // Memoized color options for react-select
  const colorOptions = useMemo(
    () =>
      availableFilters.colors.map((color: any) => ({
        value: color.value,
        label: (
          <div className={styles.colorOption}>
            <span className={styles.colorText}>
              {color.label}
              <span className={styles.colorCount}>({color.count})</span>
            </span>
          </div>
        ),
        data: color,
      })),
    [availableFilters.colors]
  );

  const selectedColorValues = useMemo(
    () =>
      selectedColors.map((color) => {
        const colorData = availableFilters.colors.find(
          (c: any) => c.value === color
        );
        return {
          value: color,
          label: (
            <div className={styles.colorOption}>
              <span className={styles.colorText}>
                {
                  // @ts-ignore
                  colorData?.label || color
                }
                <span className={styles.colorCount}>
                  (
                  {
                    // @ts-ignore
                    colorData?.count || 0
                  }
                  )
                </span>
              </span>
            </div>
          ),
        };
      }),
    [selectedColors, availableFilters.colors]
  );

  // Get series icon and background
  const seriesIcon = series
    ? seriesIcons[series.title as keyof typeof seriesIcons]
    : faChair;
  const seriesBackground = series
    ? seriesBackgrounds[series.title as keyof typeof seriesBackgrounds]
    : "https://images.unsplash.com/photo-1497366811353-6870744d04b2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80";

  if (loading && initialLoadRef.current) {
    return (
      <div className={styles.loadingContainer}>
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.errorContainer}>
        <div className={styles.errorIcon}>⚠️</div>
        <div className={styles.errorMessage}>{error}</div>
        <button
          className={styles.retryButton}
          onClick={() => window.location.reload()}
        >
          Try Again
        </button>
      </div>
    );
  }

  if (!series) {
    navigate("/gallery");
    return null;
  }

  return (
    <>
      <Helmet>
        <title>
          Scadel Furniture | {series.title} - Commercial Office Furniture
        </title>
        <meta
          name="description"
          content={`Explore our ${series.title} collection - premium commercial office furniture designed for comfort, durability, and style.`}
        />
        <link rel="canonical" href={`/series/${seriesId}`} />
      </Helmet>

      <div className={styles.seriesPage}>
        {/* Enhanced Hero Section */}
        <div
          className={styles.heroSection}
          style={{
            backgroundImage: `linear-gradient(rgba(44, 62, 80, 0.85), rgba(52, 73, 94, 0.85)), url(${seriesBackground})`,
          }}
        >
          <div className={styles.heroBackground}></div>
          <div className={styles.heroContent}>
            <motion.div
              className={styles.heroBadge}
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
            >
              <FontAwesomeIcon icon={seriesIcon} /> {series.title} Series
            </motion.div>
            <h1 className={styles.heroTitle}>
              <span className={styles.gradientText}>{series.title}</span>
              <br />
              Collection
            </h1>
            <p className={styles.heroSubtitle}>
              {series.description ||
                `Discover our comprehensive range of ${series.title.toLowerCase()} furniture, meticulously designed for commercial spaces with focus on ergonomics, durability, and modern aesthetics.`}
            </p>

            <div className={styles.heroStats}>
              <div className={styles.statItem}>
                <span className={styles.statNumber}>{totalProducts}</span>
                <span className={styles.statLabel}>Models</span>
              </div>
              <div className={styles.statDivider}></div>
              <div className={styles.statItem}>
                <span className={styles.statNumber}>Premium</span>
                <span className={styles.statLabel}>Quality</span>
              </div>
              <div className={styles.statDivider}></div>
              <div className={styles.statItem}>
                <span className={styles.statNumber}>Commercial</span>
                <span className={styles.statLabel}>Grade</span>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className={styles.mainContent}>
          {/* Page Header */}
          <div className={styles.pageHeader}>
            <div className={styles.headerLeft}>
              <h2>{series.title} Products</h2>
              <p>{totalProducts} premium models available</p>
            </div>
            <div className={styles.headerRight}>
              <h5 onClick={() => setShowFilters(!showFilters)}>
                <FontAwesomeIcon icon={faSlidersH} />
                &nbsp;&nbsp;
                {showFilters ? "Close" : "Show"} Filters
                {appliedFiltersCount > 0 && (
                  <span className={styles.activeFiltersCount}>
                    ({appliedFiltersCount})
                  </span>
                )}
              </h5>

              <div className={styles.resultsCount}>
                Showing {Math.min(currentPage * pageSize + 1, totalProducts)}-
                {Math.min((currentPage + 1) * pageSize, totalProducts)} of{" "}
                {totalProducts} products
              </div>
            </div>
          </div>

          {/* Filter and Content Area */}
          <div
            className={classNames(
              styles.contentGrid,
              !showFilters ? styles.filtershidden : ""
            )}
          >
            {/* Enhanced Filter Sidebar */}
            {showFilters && (
              <aside
                className={`${styles.filterSidebar} ${
                  mobileFiltersOpen ? styles.mobileFiltersOpen : ""
                }`}
              >
                <div className={styles.sidebarHeader}>
                  <div className={styles.filtersHeaderWrapper}>
                    <h3>
                      <FontAwesomeIcon icon={faFilter} /> Filters
                      {appliedFiltersCount > 0 && (
                        <span className={styles.activeFiltersCount}>
                          ({appliedFiltersCount})
                        </span>
                      )}
                    </h3>

                    <div className={styles.filterActions}>
                      <button
                        className={styles.closeFiltersButton}
                        onClick={() => setMobileFiltersOpen(false)}
                        aria-label="Close filters"
                      >
                        <FontAwesomeIcon icon={faTimes} />
                      </button>
                    </div>
                  </div>
                </div>

                <div className={styles.sidebarContent}>
                  {/* Search Section */}
                  <div className={styles.filterSection}>
                    <div className={styles.filterGroup}>
                      <label className={styles.filterLabel}>
                        <FontAwesomeIcon icon={faSearch} /> Search Products
                      </label>
                      <div className={styles.searchBox}>
                        <FontAwesomeIcon
                          icon={faSearch}
                          className={styles.searchIcon}
                        />
                        <input
                          type="text"
                          placeholder={`Search ${series.title} products...`}
                          value={searchQuery}
                          onChange={handleSearchChange}
                          className={styles.searchInput}
                          aria-label="Search products"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Price Range */}
                  <div className={styles.filterSection}>
                    <h4 className={styles.filterSectionTitle}>
                      <FontAwesomeIcon icon={faDollarSign} /> Price Range
                    </h4>
                    <div className={styles.priceRangeContainer}>
                      <PriceRangeSlider
                        min={availableFilters.priceRange.minPrice}
                        max={availableFilters.priceRange.maxPrice}
                        values={priceRange}
                        onChange={handlePriceChange}
                        className={styles.priceSlider}
                      />
                      <div className={styles.priceRangeValues}>
                        <span>₹{priceRange[0]?.toLocaleString() || 0}</span>
                        <span>₹{priceRange[1]?.toLocaleString() || 0}</span>
                      </div>
                    </div>
                  </div>

                  {/* Color Filter */}
                  {availableFilters.colors.length > 0 && (
                    <div className={styles.filterSection}>
                      <h4 className={styles.filterSectionTitle}>
                        <FontAwesomeIcon icon={faPalette} /> Color
                      </h4>
                      <div className={styles.colorSelectContainer}>
                        <Select
                          isMulti
                          options={colorOptions}
                          value={selectedColorValues}
                          onChange={(selectedOptions) => {
                            const selectedValues = selectedOptions
                              ? selectedOptions.map((option) => option.value)
                              : [];
                            setSelectedColors(selectedValues);
                          }}
                          className={styles.colorSelect}
                          classNamePrefix="color-select"
                          placeholder="Search and select colors..."
                          noOptionsMessage={({ inputValue }) =>
                            inputValue
                              ? "No colors found"
                              : "No colors available"
                          }
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          isSearchable={true}
                          isClearable={false}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            control: (base, state) => ({
                              ...base,
                              border: `2px solid ${
                                state.isFocused
                                  ? "var(--accent-warm)"
                                  : "var(--border-medium)"
                              }`,
                              borderRadius: "var(--border-radius-sm)",
                              padding: "4px 8px",
                              backgroundColor: "var(--glass-bg)",
                              boxShadow: state.isFocused
                                ? "0 0 0 3px rgba(212, 165, 116, 0.1)"
                                : "var(--shadow-sm)",
                              minHeight: "52px",
                              transition: "var(--transition)",
                              "&:hover": {
                                borderColor: state.isFocused
                                  ? "var(--accent-warm)"
                                  : "var(--accent-warm)",
                              },
                            }),
                            menu: (base) => ({
                              ...base,
                              borderRadius: "var(--border-radius)",
                              border: "1px solid var(--border-light)",
                              boxShadow: "var(--shadow-lg)",
                              overflow: "hidden",
                              backgroundColor: "var(--glass-bg)",
                              backdropFilter: "blur(12px)",
                              zIndex: 9999,
                            }),
                          }}
                          components={{
                            MultiValueContainer: ({ children }) => (
                              <div className={styles.multiValueContainer}>
                                {children}
                              </div>
                            ),
                            MultiValueRemove: ({ innerProps }) => (
                              <div
                                {...innerProps}
                                className={styles.multiValueRemove}
                              >
                                <FontAwesomeIcon icon={faTimes} />
                              </div>
                            ),
                            IndicatorSeparator: () => null,
                            DropdownIndicator: () => (
                              <div className={styles.dropdownIndicator}>
                                <FontAwesomeIcon icon={faChevronDown} />
                              </div>
                            ),
                            ClearIndicator: () => null,
                          }}
                        />
                      </div>

                      {/* Selected colors summary */}
                      {selectedColors.length > 0 && (
                        <div className={styles.selectedColorsSummary}>
                          <div className={styles.selectedColorsHeader}>
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              className={styles.selectedIcon}
                            />
                            <span>
                              {selectedColors.length} color
                              {selectedColors.length !== 1 ? "s" : ""} selected
                            </span>
                            <button
                              className={styles.clearColorsButton}
                              onClick={clearSelectedColors}
                            >
                              Clear all
                            </button>
                          </div>
                          <div className={styles.selectedColorsList}>
                            {selectedColors.slice(0, 8).map((color) => {
                              const colorData = availableFilters.colors.find(
                                (c: any) => c.value === color
                              );
                              return (
                                <span
                                  key={color}
                                  className={styles.selectedColorTag}
                                >
                                  {
                                    // @ts-ignore
                                    colorData?.label || color
                                  }
                                  <button
                                    onClick={() => handleColorChange(color)}
                                    className={styles.removeColorButton}
                                  >
                                    <FontAwesomeIcon icon={faTimes} />
                                  </button>
                                </span>
                              );
                            })}
                            {selectedColors.length > 8 && (
                              <span className={styles.moreColorsTag}>
                                +{selectedColors.length - 8} more
                              </span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Sort Options */}
                  {/* <div className={styles.filterSection}>
                    <h4 className={styles.filterSectionTitle}>
                      <FontAwesomeIcon icon={faSortAmountDown} /> Sort By
                    </h4>
                    <Select
                      className={styles.select}
                      classNamePrefix="select"
                      options={sortOptions}
                      value={sortOptions.find(
                        (opt) => opt.value === sortOption
                      )}
                      onChange={handleSortChange}
                      isSearchable={false}
                      aria-label="Select sort option"
                    />
                  </div> */}
                  {/* Sort Options */}
                  <div className={styles.filterSection}>
                    <h4 className={styles.filterSectionTitle}>
                      <FontAwesomeIcon icon={faSortAmountDown} /> Sort By
                    </h4>
                    <Select
                      className={styles.select}
                      classNamePrefix="select"
                      options={sortOptions}
                      value={sortOptions.find(
                        (opt) => opt.value === sortOption
                      )}
                      onChange={handleSortChange}
                      isSearchable={false}
                      formatOptionLabel={formatOptionLabel}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 10001 }),
                        menu: (base) => ({ ...base, zIndex: 10001 }),
                      }}
                      aria-label="Select sort option"
                    />
                  </div>
                </div>

                {/* Mobile Apply Filters Button */}
                <div className={styles.mobileApplyButton}>
                  <button
                    className={styles.applyFiltersButton}
                    onClick={() => setMobileFiltersOpen(false)}
                  >
                    Apply Filters
                  </button>
                </div>
              </aside>
            )}

            {/* Products Area */}
            <main className={styles.productsArea}>
              {/* Mobile Filter Header */}
              <div className={styles.mobileFilterHeader}>
                <button
                  className={styles.mobileFilterButton}
                  onClick={() => setMobileFiltersOpen(true)}
                  aria-label="Open filters"
                >
                  <FontAwesomeIcon icon={faFilter} />
                  Filters
                  {appliedFiltersCount > 0 && (
                    <span className={styles.filterBadge}>
                      {appliedFiltersCount}
                    </span>
                  )}
                </button>

                <div className={styles.viewOptions}>
                  <label>Show:</label>
                  <select
                    value={pageSize}
                    onChange={handlePageSizeChange}
                    className={styles.pageSizeSelect}
                    aria-label="Items per page"
                  >
                    <option value={12}>12</option>
                    <option value={24}>24</option>
                    <option value={36}>36</option>
                    <option value={48}>48</option>
                  </select>
                </div>
              </div>

              {/* Active Filters Display */}
              {appliedFiltersCount > 0 && (
                <div className={styles.activeFilters}>
                  <div className={styles.activeFiltersHeader}>
                    <span>Active Filters:</span>
                    <button onClick={resetFilters}>Clear All</button>
                  </div>
                  <div className={styles.activeFiltersList}>
                    {searchQuery && (
                      <span className={styles.activeFilter}>
                        Search: "{searchQuery}"
                        <button onClick={() => setSearchQuery("")}>×</button>
                      </span>
                    )}
                    {(priceRange[0] > availableFilters.priceRange.minPrice ||
                      priceRange[1] < availableFilters.priceRange.maxPrice) && (
                      <span className={styles.activeFilter}>
                        Price: ₹{priceRange[0]?.toLocaleString()} - ₹
                        {priceRange[1]?.toLocaleString()}
                        <button
                          onClick={() =>
                            setPriceRange([
                              availableFilters.priceRange.minPrice,
                              availableFilters.priceRange.maxPrice,
                            ])
                          }
                        >
                          ×
                        </button>
                      </span>
                    )}
                    {selectedColors.map((color) => (
                      <span key={color} className={styles.activeFilter}>
                        Color: {color}
                        <button onClick={() => handleColorChange(color)}>
                          ×
                        </button>
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {/* Products Grid */}
              <AnimatePresence mode="wait">
                <motion.div
                  key={`${currentPage}-${searchQuery}`}
                  className={styles.productsGrid}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.3 }}
                >
                  {products?.length > 0 ? (
                    products.map((product) => (
                      <ProductCard
                        key={product._id}
                        product={product}
                        series={series}
                      />
                    ))
                  ) : (
                    <div className={styles.noProducts}>
                      <div className={styles.noProductsIcon}>🛋️</div>
                      <h3>No products found</h3>
                      <p>Try adjusting your filters or search terms</p>
                      <button
                        className={styles.resetFiltersButton}
                        onClick={resetFilters}
                      >
                        Reset All Filters
                      </button>
                    </div>
                  )}
                </motion.div>
              </AnimatePresence>

              {/* Pagination */}
              {totalProducts > pageSize && (
                <div className={styles.paginationContainer}>
                  <ReactPaginate
                    previousLabel={<FontAwesomeIcon icon={faArrowLeft} />}
                    nextLabel={<FontAwesomeIcon icon={faArrowRight} />}
                    pageCount={Math.ceil(totalProducts / pageSize)}
                    onPageChange={handlePageClick}
                    containerClassName={styles.pagination}
                    previousLinkClassName={styles.paginationLink}
                    nextLinkClassName={styles.paginationLink}
                    disabledClassName={styles.paginationDisabled}
                    activeClassName={styles.paginationActive}
                    forcePage={currentPage}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    pageClassName={styles.paginationItem}
                    pageLinkClassName={styles.paginationPageLink}
                  />
                </div>
              )}
            </main>
          </div>
        </div>

        {/* Enhanced CTA Section */}
        <div className={styles.ctaSection}>
          <div className={styles.ctaBackground}></div>
          <div className={styles.ctaContent}>
            <div className={styles.ctaIcon}>📦</div>
            <h3 className={styles.ctaTitle}>Bulk Order Inquiries?</h3>
            <p className={styles.ctaText}>
              Get special pricing on bulk orders and customized solutions
              tailored to your commercial space requirements. Our team is ready
              to assist you.
            </p>
            <div className={styles.ctaButtons}>
              <button
                className={styles.ctaButtonPrimary}
                onClick={() => (window.location.href = "/contact")}
              >
                <span>Request Quote</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 12H19M19 12L12 5M19 12L12 19"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <button
                className={styles.ctaButtonSecondary}
                onClick={() => (window.location.href = "/catalog")}
              >
                Download Catalog
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Floating Filter Button */}
        <button
          className={styles.floatingFilterButton}
          onClick={() => setMobileFiltersOpen(true)}
          aria-label="Open filters"
        >
          <FontAwesomeIcon icon={faFilter} />
          {appliedFiltersCount > 0 && (
            <span className={styles.floatingFilterBadge}>
              {appliedFiltersCount}
            </span>
          )}
        </button>

        {/* Mobile Overlay */}
        {mobileFiltersOpen && (
          <div
            className={styles.mobileOverlay}
            onClick={() => setMobileFiltersOpen(false)}
          />
        )}
      </div>
    </>
  );
};

export default SeriesPage;
